const boUrl = {
  url() {
    if (window.location.host === 'shopkeep-support.lightspeedhq.com') {
      return 'https://shopkeepapp.com';
    }
    return 'https://getshopkeep.com';
  },
  init() {
    window.bo_root = this.url();
  }
};

export default boUrl;
